<template>
    <section class="barocare-conci-banner" id="barocare-conci-banner">
        <div class="alliance-slide-cont">
            <div class="title-area" v-intersect>
                   <div class="title-left">
                      <h2 class="text-xl"> 
                      1,500여개의 병의원과
                      <br>함께하고 있습니다
                      </h2>
                  </div>
                  <div class="title-right">
                   <p>
                    내과, 소아과, 가정의학과를 포함한 <br>
                    다양한 분야의 의료진이 파트너로 함께합니다
                    </p>           
                  </div>
            </div>    
            <div class="slide-wrap" v-intersect>
                <ul class="alliance-list to-right">
                    <li v-for="item in repeatedItems1" :key="item.id">
                        <img :src="item.imageUrl" :alt="item.altText">
                    </li>
                </ul>
                <ul class="alliance-list to-left">
                    <li v-for="item in repeatedItems2" :key="item.id">
                        <img :src="item.imageUrl" :alt="item.altText">
                    </li>
                </ul>
            </div>
        </div>
        <div class="use-cont" >
            <div class="use-container-lg" >
                <div class="title-area" v-intersect>
                    <div class="title-left">
                        <h2 class="text-xl"> 
                        이용 방법
                        </h2>
                    </div>
                    <div class="title-right">
                        <p>
                        <strong>진료 예약부터 소모품 배송까지</strong><br>
                        쉽고 편리하게 이용하세요
                        </p>           
                    </div>
                </div>
                <div class="bot-area" v-intersect>
                    <ol class="box-list">
                        <li class="box">
                            <span class="text-num">01</span>
                            <strong class="text-tit">코디 상담</strong>
                            <div class="img-wrap">
                            </div>
                        </li>
                        <li class="box">
                            <span class="text-num">02</span>
                            <strong class="text-tit">전화 진료</strong>
                            <div class="img-wrap">
                            </div>
                        </li>
                        <li class="box">
                            <span class="text-num">03</span>
                            <strong class="text-tit">처방전 발급</strong>
                            <div class="img-wrap">
                            </div>
                        </li>
                        <li class="box">
                            <span class="text-num">04</span>
                            <strong class="text-tit">물품 배송</strong>
                            <div class="img-wrap"> 
                            </div>
                        </li>
                    </ol>
                    <p class="tip">* 최초 1회에 한하여 환자 정보를 등록해야 합니다</p>   
                </div>

            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'BarocareConcibanner',
    directives: {
        intersect: {
            // 요소가 DOM에 삽입될 때 호출됩니다.
            inserted(el) {
                const options = {
                    root: null, // 뷰포트를 기본값으로 설정
                    rootMargin: '0px', // 뷰포트의 마진은 0
                    threshold: 0.1 // 10%가 보일 때 콜백이 실행
                };
                const callback = (entries, observer) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            el.classList.add('visible');
                        } else {
                            el.classList.remove('visible');
                        }
                    });
                };
                const observer = new IntersectionObserver(callback, options);
                observer.observe(el); // 해당 요소를 관찰 시작
            }
        }
    },
    data() {
        return {
            items1: [
                { id: 1, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo21.png'), altText: '삼성키즈소아청소년과'},
                { id: 2, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo23.png'), altText: '다나아내과의원'},
                { id: 3, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo29.png'), altText: '조준형내과의원'},
                { id: 4, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo27.png'), altText: '트리니티내과'},
                { id: 5, imageUrl: require('../../assets/pc_barocare_b2c/alliance-logo16.png'), altText: '연세유원내과'},
                { id: 6, imageUrl: require('../../assets/pc_barocare_conci/alliance-logo01.png'), altText: 'jm가정의학과 jm의원 부산지점'},
                { id: 7, imageUrl: require('../../assets/pc_barocare_conci/alliance-logo02.png'), altText: '한내과 소아과 건강검진센터'},
                { id: 8, imageUrl: require('../../assets/pc_barocare_conci/alliance-logo03.png'), altText: '서래가정의학과의원'},
            ],
            items2: [
                { id: 9, imageUrl: require('../../assets/pc_barocare_conci/alliance-logo2-1.png'), altText: '윤석주내과'},
                { id: 10, imageUrl: require('../../assets/pc_barocare_conci/alliance-logo2-2.png'), altText: '강남성모내과'},
                { id: 11, imageUrl: require('../../assets/pc_barocare_conci/alliance-logo2-3.png'), altText: '연세한결소아청소년과의원'}, 
                { id: 12, imageUrl: require('../../assets/pc_barocare_conci/alliance-logo2-4.png'), altText: '아이쑥쑥소아청소년과의원'},
                { id: 13, imageUrl: require('../../assets/pc_barocare_conci/alliance-logo2-5.png'), altText: '예지소아청소년과의원'},
                { id: 14, imageUrl: require('../../assets/pc_barocare_conci/alliance-logo2-6.png'), altText: '압구정하나내과의원'},
                { id: 15, imageUrl: require('../../assets/pc_barocare_conci/alliance-logo2-7.png'), altText: '365류내과의원'},
                { id: 16, imageUrl: require('../../assets/pc_barocare_conci/alliance-logo2-8.png'), altText: '신나라소아청소년과의원'},
                { id: 17, imageUrl: require('../../assets/pc_barocare_conci/alliance-logo2-9.png'), altText: '365연합소아청소년과의원'},
            ],
            repeatCount: 6
        }
    },
    computed: {
        repeatedItems1() {
            let result = [];
            for (let i = 0; i < this.repeatCount; i++) {
                this.items1.forEach(item => {
                    result.push({
                        ...item,
                        id: `${item.id}-${i}`
                    });
                });
            }
            return result;
        },
        repeatedItems2() {
            let result = [];
            for (let i = 0; i < this.repeatCount; i++) {
                this.items2.forEach(item => {
                    result.push({
                        ...item,
                        id: `${item.id}-${i}`
                    });
                });
            }
            return result;
        }
    },
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/pc_barocare_conci/BarocareConciBanner.vue